<template>
  <div>
    <!-- PROJECT PREVIEW -->
    <div
      class="ProjectContent"
      :style="getProjectStyle"
      @click="selectProject()"
      v-if="!isSelected"
    >
      <img
        v-bind:src="this.getImgPath"
        :style="{
            objectPosition: this.getImgOffset
          }"
        class="projectImg"
      />

      <transition name="fade">
        <div
          v-show="this.isOver"
          class="projectVideoFrame"
        >

          <div
            :style="{
            top: getVideoOffset + 'px',
            left: '0px',
            position: 'absolute',
            width: this.getVideoWidth + 'px',
            height: this.getVideoHeight + 'px'
          }"
          >
            <!--img v-if="this.pProject.introGif.length > 0" class="introVideoC" :style="getGifSize" src="http://64.227.16.239:1337/uploads/ezgif_com_gif_maker_4b9f2c80b9.gif" /-->

            <img v-if="this.pProject.introGif.length > 0" :src="this.getIntroGifPath" class="introVideoC" :style="getGifSize" />

            <!--video
              ref="player"
              id="test"
              :src="this.getIntroVideoPath"
              class="introVideoC"
              :width="this.getVideoWidth"
              :height="this.getVideoHeight"
              muted
              loop
              autoplay="true"
              v-if="this.pProject.introVideo && !this.pProject.introGif"
            ></video-->

            <vueVimeoPlayer
              ref="player"
              :video-id="this.pProject.titleVideo"
              loop="true"
              controls="false"
              :options="{muted: 'true', t: '3s'}"
              :playerWidth="this.getVideoWidth"
              :playerHeight="this.getVideoHeight"
              autoplay="true"
              @ready="onReady"
              @loaded="onLoaded"
              v-if="this.pProject.titleVideo && this.pProject.introGif.length == 0"
            ></vueVimeoPlayer>

          </div>

        </div>
      </transition>
      <div
        class="projectDescFrame"
        :style="getFixedStyle"
        @mouseover="handleMouseOver"
        @mouseleave="handleMouseLeave"
      >
        <div class="projectDesc" :style="getDescStyle">
          <div class="private" v-if="this.pProject.isPrivate == true"><div style="padding: 15px">PRIVATE</div></div>
          <div class="projectContent">
            <div class="projectMainCategory">
              <span v-if="this.pProject.isFeatured == true" class="featuredInline">Featured</span>
              {{this.getMainCategory}}
              <span :style="{paddingLeft: '10px'}">
                <span v-if="this.pProject.isFeatured == -1" class="featured">Featured</span>
              </span>

              <div class="projectDate">{{this.getDate}}</div>
            </div>
            <div class="projectDescTitle">
              <!--div class="projectLine" :style="getTypeClass"></div-->
              <div :style="getProjectTitleStyle">{{this.pProject.title}}</div>
            </div>

            <transition name="">
              <div class="projectSubtitle" v-show="this.isOver">{{this.getSubtitle}}</div>
            </transition>
          </div>

          <transition name="fade">
            <div class="categoryLinkFrame" v-show="false && this.isOver">
              <span
                v-for="(_cat, index) in this.pProject.madsci_categories"
                :key="index"
                class="categoryLinkPadding"
              >
                <span class="categoryLink">{{_cat.title}}</span>
              </span>
            </div>
          </transition>

          
        </div>

      </div>
    </div>

    <!-- PROJECT DETAIL -->

    <div class="ProjectContent" :style="getProjectStyle" v-if="isSelected">
      <div class="projectMainContentWrapper">
        <div class="projectMainContent" :style="getContentWidth">
          <div v-if="this.pProject.subTitle != ''">
            <div v-if="this.tIsMobile" class="projectDateSelected">{{this.getDate}}</div>
            
            <h1>{{this.pProject.subTitle}}</h1>
            <p></p>
          </div>

          <div v-if="this.tIsMobile" class="projectSideFrameMobile">
            <div class="projectDescSelectedMobile">

            <div v-if="!this.showProjectCredits">
              <div class="toggleCredits" @click="this.toggleCredits">show credits</div>
            </div>

            <div v-if="this.showProjectCredits">

              <div class="toggleCredits" @click="this.toggleCredits">hide credits</div>

            <div
              class="projectCreditFrameMobile"
              v-if="this.pProject.madsci_members && this.pProject.madsci_members.length > 0 && !this.pProject.customCredits"
            >
              <div class="projectCreditTitle">Lab credits:</div>

              <div
                v-for="(_member, index) in this.pProject.madsci_members"
                :key="index"
                class="projectPostedBy"
              >{{_member.Name}}</div>
            </div>

            <div v-if="this.pProject.customCredits" class="projectCreditFrameMobile">
              
              <div class="projectCreditTitle">Lab credits:</div>

              <div 
                v-for="(_credit, index) in this.getAdditionalCredits(this.pProject.customCredits)"
                :key="index"
              >
              <div class="projectPostedBy">{{_credit[0]}}</div>
              <div class="projectPostedBySubtitle">{{_credit[1]}}</div>
              </div>
            </div>

            <div class="projectCreditFrameMobile" v-if="this.pProject.madsci_member_intern">
              <div class="projectCreditTitle">Intern:</div>
              {{this.pProject.madsci_member_intern.Name}}
            </div>

            <div class="projectCreditFrameMobile"
                v-for="(_credit, index) in this.getAdditionalCredits(this.pProject.additionalCredits)"
                :key="index"
            >
              <div class="projectCreditTitle">{{_credit[0]}}:</div>
              {{_credit[1]}}
            </div>

            <div
              class="projectCreditFrameMobile"
              v-if="this.pProject.madsci_member_posted && this.pProject.madsci_member_posted.length > 0"
            >
              <div class="projectCreditTitle">Posted by:</div>
              {{this.pProject.madsci_member_posted[0].Name}}
            </div>

            </div>
            </div>
          </div>
  
          <div v-html="getContentSet(0)"></div>
          <ImageCarousel
            :pWidth="getCarouselWidth"
            :pHeight="getCarouselHeight"
            :pThumbDiv="10"
            :pMediaArr="getMediaArray(1)"
            v-if="getMediaArrayCount(1) > 0"
          />
          <div v-html="getContentSet(1)"></div>
          <ImageCarousel
            :pWidth="getCarouselWidth"
            :pHeight="getCarouselHeight"
            :pThumbDiv="12"
            :pMediaArr="getMediaArray(2)"
            v-if="getMediaArrayCount(2) > 0"
          />

          <div v-html="getContentSet(2)"></div>
        </div>
      </div>

      <div v-if="!this.tIsMobile" class="projectSideFrame">
        <div class="projectDescSelected" :style="getDescStyle">
          
          <div class="projectContent" >
            <div class="projectMainCategorySide">{{this.getMainCategory}}</div>
            <div class="projectDescTitleSide">
              <!--div class="projectLine" :style="getTypeClass"></div-->
              <div class="projectTitleBuffer">{{this.pProject.title}}</div>
            </div>

            <div class="projectSubtitle" v-show="this.isOver">{{this.getSubtitle}}</div>

            <div class="projectDateSelected">{{this.getDate}}</div>

            <div class></div>

            <div
              class="projectCreditFrame"
              v-if="this.pProject.madsci_members && this.pProject.madsci_members.length > 0 && !this.pProject.customCredits"
            >
              <div class="projectCreditTitle">Lab credits:</div>

              <div
                v-for="(_member, index) in this.pProject.madsci_members"
                :key="index"
                class="projectPostedBy"
              >{{_member.Name}}</div>
            </div>

            <div v-if="this.pProject.customCredits" class="projectCreditFrame">
              
              <div class="projectCreditTitle">Lab credits:</div>

              <div 
                v-for="(_credit, index) in this.getAdditionalCredits(this.pProject.customCredits)"
                :key="index"
              >
              <div class="projectPostedBy">{{_credit[0]}}</div>
              <div class="projectPostedBySubtitle">{{_credit[1]}}</div>
              </div>
            </div>

            <div class="projectCreditFrame" v-if="this.pProject.madsci_member_intern">
              <div class="projectCreditTitle">Intern:</div>
              {{this.pProject.madsci_member_intern.Name}}
            </div>

            <div class="projectCreditFrame"
                v-for="(_credit, index) in this.getAdditionalCredits(this.pProject.additionalCredits)"
                :key="index"
            >
              <div class="projectCreditTitle">{{_credit[0]}}:</div>
              {{_credit[1]}}
            </div>

            <div
              class="projectCreditFrame"
              v-if="this.pProject.madsci_member_posted && this.pProject.madsci_member_posted.length > 0"
            >
              <div class="projectCreditTitle">Posted by:</div>
              {{this.pProject.madsci_member_posted[0].Name}}
            </div>

            <div class="categoryLinkFrameSelected">
              <div
                v-for="(_cat, index) in this.pProject.madsci_categories"
                :key="index"
                class="categoryLinkPaddingSelected"
                @click="clickCategory()"
                @mouseOver="this.isOver=true"
                @mouseLeave="this.isOver=false"
              >
                <span class="categoryLinkSelected">{{_cat.title}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>
import StrapiService from "@/services/StrapiService.js";
import { vueVimeoPlayer } from "vue-vimeo-player";
import ImageCarousel from "@/components/ImageCarousel.vue";

//import gsap from "gsap";
import { EventBus } from "@/event-bus.js";
import { isMobile } from 'mobile-device-detect'

export default {
  //components: {  ImageCarousel },
  components: { vueVimeoPlayer, ImageCarousel },
  props: {
    pIsSelected: {
      type: Boolean,
      return: false
    },
    pProject: {
      type: Object,
      return: null,
    },
    pWidth: {
      type: Number,
      return: 1280,
    },
    pHeight: {
      type: Number,
      return: 720,
    },
    pIndex: {
      type: Number,
      return: 0,
    },
    pSelectedProjectIndex: {
      type: Number,
      return: 0,
    },
  },
  watch: {
    pIndex: function (_i) {
      console.log(_i);
      this.createContentSet();
    },
  },
  created() {

    this.createContentSet()
  },
  methods: {

    toggleCredits: function() {

      this.isMenuOpen = !this.isMenuOpen
    },

    createContentSet: function() {

      var _arr = []
      
      if (this.pProject.content) {
        _arr = this.pProject.content.split("TGALLERY")
      }

      if (_arr.length > 1) {

        for (var i=0; i<3; i++) {
          this.contentSet[i] = _arr[i]
        }
      } else {
        this.contentSet[1] = this.pProject.content
      }
    },

    clickCategory: function() {

    },

    getContentSet: function(_index) {

      return this.contentSet[_index]
      //<div v-html="this.pProject.content"></div>

    },

    getAdditionalCredits: function(_val) {

      if (_val) {

        var _out = []
        var _arr = _val.split("\n\n");

        for (var i=0; i<_arr.length; i++) {

          var _s = _arr[i].split("\n")

          if (_s.length > 1) {
            _out.push(_s)
          }
        }

        console.log("* ARRAY")
        console.log(_out)

        return _out

      } else {

        return []
      }

    },

    getMediaArray(_index) {
      if (_index == 1) {
        if (this.pProject.madsci_media_items_1 && this.pProject.madsci_media_items_1.length > 0) {
          return this.pProject.madsci_media_items_1;
        } else if (this.pProject.image_carousel_1) {
          return this.pProject.image_carousel_1;
        }
      } else if (_index == 2) {
        if (this.pProject.madsci_media_items_2 && this.pProject.madsci_media_items_2.length > 0) {
          return this.pProject.madsci_media_items_2;
        } else if (this.pProject.image_carousel_2) {
          return this.pProject.image_carousel_2;
        }
      }
    },
    getMediaArrayCount(_index) {
      if (_index == 1) {
        if (this.pProject.madsci_media_items_1 && this.pProject.madsci_media_items_1.length > 0) {
          return this.pProject.madsci_media_items_1.length;
        } else if (this.pProject.image_carousel_1) {
          return this.pProject.image_carousel_1.length;
        }
      } else if (_index == 2) {
        if (this.pProject.madsci_media_items_2 && this.pProject.madsci_media_items_2.length > 0) {
          return this.pProject.madsci_media_items_2.length;
        } else if (this.pProject.image_carousel_2) {
          return this.pProject.image_carousel_2.length;
        }
      }
    },
    selectProject() {
      //this.isSelected = !this.isSelected;

      /*gsap.to(".projectPreview", {
        duration: 0.35,
        height: this.getMainHeight,
      });*/

      console.log(">>> SELECT PROJECT : " + this.pIndex)
      EventBus.$emit("select-project", this.pIndex);
    },
    onProgress(data) {
      console.log(data);
      if (data > 0) {
        this.playerReady = true;
      }
    },
    onLoaded() {
      // console.log("v> loaded");
      this.playerLoaded = true;
      this.pause();
    },
    onReady() {
      //console.log("v> ready");
      this.playerReady = true;
    },
    play() {
      console.log("v> play");
      //this.$refs.player.setCurrentTime(3.0);

      if (this.$refs.player) {
        this.$refs.player.play();
      }
    },
    pause() {
      this.$refs.player.pause();
    },
    handleMouseOver: function () {

      if (!this.playerPlaying) {
        this.play();
        this.playerPlaying = true;
      }

      this.isOver = true;

    },
    handleMouseDown: function () {

      if (this.tIsMobile) {
        this.handleMouseOver
      }
    },
    
    handleMouseUp: function () {

      if (this.tIsMobile) {
        this.isOver = false;
      }
    },

    handleMouseLeave: function () {

      this.isOver = false;

      /*
      this.pause();
      this.playerPlaying = false;
      */
    },
    getMonthName(_index) {
      switch (_index) {
        case 0:
          return "January";
        case 1:
          return "February";
        case 2:
          return "March";
        case 3:
          return "April";
        case 4:
          return "May";
        case 5:
          return "June";
        case 6:
          return "July";
        case 7:
          return "August";
        case 8:
          return "September";
        case 9:
          return "October";
        case 10:
          return "November";
        case 11:
          return "December";
      }
    },
  },
  computed: {

    showProjectCredits: function() {

      return this.isMenuOpen
    },
    getGifSize: function() {

      if (this.isOver) {
        console.log(this.getVideoWidth + "," + this.getVideoHeight)
      }
      return {
        width: this.getVideoWidth + 'px',
        height: this.getVideoHeight + 'px'
      }
    },
    getCarouselWidth: function() {
      
      return !this.tIsMobile ? 640 : window.innerWidth * .95
    },

    getCarouselHeight: function() {
      
      return !this.tIsMobile ? 360 : window.innerWidth * .95 / 2
    },

    getContentWidth: function() {

      if (this.tIsMobile) {
        return {paddingTop: '0px', paddingLeft: '10px', width: '95vw'};
      } else {
        return {width: '650px'};
      }
    },

    getProjectTitleStyle: function() {

      var _fontSize = "3.7vw"
      if (this.pProject.title.length > 45) {
        _fontSize = "3vw"
      } else if (this.pProject.title.length > 35) {
        _fontSize = "3.3vw"
      }

      return {
        fontSize: _fontSize, //this.pProject.title.length < 35 ? '4vw' : '3.5vw',
        textDecoration: this.isOver ? 'underline' : ''
      }
    },

    isPlayerReady: function() {

      if (
          (this.playerLoaded == true && this.playerReady == true)
          ||
          this.pProject.introVideo
      )
      {
        return true
      } else {
        return false
      }

    },
    isSelected: function () {
      if (this.pIsSelected) {
        return true;
      } else {
        return false;
      }
    },
    getFixedStyle: function () {
      if (this.isSelected) {
        return { position: "fixed" };
      } else {
        return {};
      }
    },
    getProjectStyle: function () {
      var _h = "28vw";
      var _p = "relative";
      var _z = 1;

      if (this.pIsSelected) {
        _h = "61vw"; //window.innerHeight - 50 + "px";
        _z = 2;
      }

      return {
        width: "100vw",
        height: _h,
        position: _p,
        zIndex: _z,
      };
    },
    getMainHeight: function () {
      return window.innerHeight - 50;
    },
    getTypeClass: function () {
      var _c = {};
      switch (this.getMainCategory) {
        case "Projects & Events":
          _c = {
            backgroundColor: "#00bb00",
            width: "150px",
          };
          break;
        case "Agency Work":
          _c = {
            backgroundColor: "#dddd00",
            width: "120px",
          };
          break;
        default:
          _c = {
            width: "195px",
            border: "solid 1px #00000033",
          };
      }

      if (this.pProject.isFeatured) {
        _c.width = "180px";
      }
      return _c;
    },
    getSubtitle: function () {
      var _t = "";
      if (this.pProject.subTitle) {
        _t = this.pProject.subTitle;
      }
      return _t;
    },
    getDate: function () {
      var _t = new Date();

      var _sd;
      if (this.pProject.date) {
        var _dat = this.pProject.date;
        var _arrD = _dat.split("-");

        _t.setMonth(_arrD[1] - 1);
        _t.setDate(_arrD[2]);
        _t.setFullYear(_arrD[0]);

        _sd =
          this.getMonthName(_t.getMonth()) +
          " " +
          _t.getDate() +
          ", " +
          _t.getFullYear();
      }

      //console.log(_sd);
      return _sd;
    },
    getMainCategory: function () {
      var _cat = "Research & Experiments";
      if (this.pProject.madsci_primary_category) {
        _cat = this.pProject.madsci_primary_category.title;
      }
      //console.log(">>" + _cat);
      return _cat;
    },
    getDescStyle: function () {

      var _backgroundColor = "#ffffff"
      var _border = ""
  
      if (this.isOver)
      {

        switch (this.getMainCategory) {
          case "Projects & Events":
            _backgroundColor = "#00bb00dd"
            break;
          case "Agency Work":
            _backgroundColor = "#eeee00dd"
            break;
          default:
            _backgroundColor = "#c9c9c955"
            break;
        }
        _border = "solid 1px #33333300"
      } else {
        _border = "solid 1px #33333366"
      }

      //console.log(_border)
  
      return {
        backgroundColor: _backgroundColor,
        border: _border
      }; //if (this.pProject.
    },

    getIntroGifPath: function() {

      var _url = "";

      if (this.pProject.introGif.length > 0)
      {
       _url = StrapiService.getApiHost() + this.pProject.introGif[0].url
       console.log("* intro gif " + _url)
      }

      return "http://" + _url;
    },

    getIntroVideoPath: function() {

      //this.pProject.introVideo
      var _url = "";

      if (this.pProject.introVideo)
      {
       _url = StrapiService.getApiHost() + this.pProject.introVideo.url
      }

      //console.log("*video : " + _url)
      //console.log(this.pProject.introVideo)

      return "http://" + _url;
    },

    getImgPath: function () {
      var _url = "";

      if (this.pProject.titleImg)
      {
        if (this.pProject.titleImg.formats && this.pProject.titleImg.formats.medium) {
          _url = StrapiService.getApiHost() + this.pProject.titleImg.formats.medium.url;
        } else if (this.pProject.titleImg) {
          _url = StrapiService.getApiHost() + this.pProject.titleImg.url;
        }
      }
      return "http://" + _url;
    },
    getVideoWidth: function () {
      return this.pWidth; //this.pWidth;
    },
    getVideoHeight: function () {
      return (this.pWidth * 720) / 1280;
    },
    getImgOffset: function () {
      var _o = "50% 50%";
      if (this.pProject.titleImgVerticalOffset) {
        _o = "50% " + this.pProject.titleImgVerticalOffset + "%";
      }

      return _o;
    },
    getVideoOffset: function () {
      var _o = 0;
      var _off = 0;
  
      if (this.pProject.videoVerticalOffset) {
        _off = this.pProject.videoVerticalOffset;
      } 
      
      _o = -0.5 * (this.getVideoHeight - this.pHeight) + _off;

      console.log(" * offset : " + _o)
      return _o;
    },
  },
  data() {
    return {
      isOver: false,
      playerReady: false,
      playerLoaded: false,
      playerPlaying: false,

      tIsMobile: isMobile ? true : false,
      contentSet: ["", "", ""],

      isMenuOpen: false

    };
  },
};
</script>

<style>

.toggleCredits {

  position: absolute;
  font-size: 11px;
  font-weight: bold;
  right: 10px;
  top: 3px;
}

.introVideoC {
  position: absolute;
  object-fit: cover;
  left:0px;
  top: 0px;
}

.projectParagraph {
  padding-top: 10px;
  padding-bottom: 10px;
}

.imgPair {
  position: relative;
  width: 100%;
  height: 300px;
  padding-top: 20px;
  padding-bottom: 10px;
}

.imgPairLeft {
  position: relative;
}

.imgPairRight {
  left: 50%;
  position: relative;
}

.projectPostedBy {
  padding-top: 5px;
}


.projectPostedBySubtitle {
  font-size: 12px;
  padding-bottom: 15px;
  padding-top: 5px;
  width: 75%;
}

.imgFull {
  width: 100%;
  border: solid 1px #33333366;
}

.imgPairImg {
  height: 265px;
  width: 49%;
  left: 0px;
  top: 0px;
  object-fit: cover;
  position: absolute;
  border: solid 1px #33333366;
}

.imgPairCaption {
  position: absolute;
  padding-top: 0px;
  font-size: 12px;
  bottom: 0px;
  padding-bottom: 20px;
}

.imgCaption {
  position: relative;
  padding-top: 0px;
  top: -15px;
  font-size: 12px;
  padding-bottom: 20px;
}

.imgCaption a {
  font-size: 12px;
}

.private {
  position: absolute;
  border: solid 1px #ff0000ff;
  background: #ff5555bb;
  padding: 0px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  width: 100%;
}

.featuredInline {
  font-weight: 400;
  color: #ff5555;
}

.featured {
  border: solid 1px #ff0000ff;
  background: #ff5555cc;
  padding: 3px;
  padding-left: 4px;
  padding-right: 4px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 400;
}
.projectDescFrame {
  position: absolute;
  width: 30.5vw;
  left: 68vw;
  height: 100%;
  padding-left: 7px;
  padding-right: 0px;
  cursor: pointer;
}

.projectSideFrameMobile {
  position: relative;
  left: 0px;
  padding-right: 0px;
  padding-bottom: 20px;
}

.projectSideFrame {
  position: fixed;
  width: 30.5vw;
  left: 68vw;
  padding-left: 13px;
  padding-right: 0px;
  padding-bottom: 60px;
}

.projectVideoFrame {
  width: 68vw;
  height: 100%;
  left: 0px;
  top: 0px;
  border: solid 1px #33333366;
  position: absolute;
  overflow: hidden;
}

.projectMainContentWrapper {
  width: 68vw;
  position: absolute;
  padding-bottom: 50px;
}

.projectMainContent {
  position: relative;
  text-align: left;
  padding-top: 0px;
  margin: auto;
  font-size: 16px;
  line-height: 1.4;

  padding-bottom: 120px;
  color: #222222;
}

.projectMainContentMobile {
 padding-top: 0px;
}

.projectMainContent a {
  font-size: 16px;
  line-height: 1.4;
  font-weight: 600;
  text-decoration: underline;
}

.projectMainContent a:hover {
  font-size: 16px;
  line-height: 1.4;
  font-weight: 600;
  background-color: #00bb00cc;
}

.projectImg {
  width: 68vw;
  height: 100%;
  left: 0px;
  top: 0px;
  object-fit: cover;
  position: absolute;
  border: solid 1px #33333366;
}

.projectDate {
  position: relative;
  bottom: 6%;
  left: 0px;
  font-weight: 400;
  top: 9px;

}

.projectDateSelected {
  position: relative;
  font-size: 16px;
  font-weight: 400;
  padding-top: 20px;
  color: #333333;
  font-style: oblique;
}

.projectCreditFrame {
  padding-top: 25px;
  font-size: 18px;
  width: 75%;
  line-height: 1.3;
}

.projectCreditFrameMobile {
  padding-top: 15px;
  font-size: 15px;
  line-height: 1.3;
}

.projectCreditTitle {
  font-size: 13px;
  font-weight: 700;
  padding-bottom: 10px;
}

.projectSubtitle {
  position: absolute;
  line-height: 1.2;
  font-weight: 400;
  margin-bottom: 15px;
  width: 80%;
  overflow: hidden;
  bottom: 0px;
}

.projectDescSelected {
  position: relative;
  width: 100%;
  height: 75vh;
  text-align: left;
  font-size: 1.3vw;
  overflow-x: hidden;
  overflow-y: scroll;
}

.projectDescSelectedMobile {
  position: relative;
  text-align: left;
  font-size: 1.3vw;
  border: solid 1px #33333366;
  padding: 20px;
  padding-top: 0px;
}

.projectDesc {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: left;
  font-size: 1.3vw;
}

.projectContent {
  padding: 8%;
  padding-top: 5%;
  position: relative;
  color: #444444;
  width: 100%;
  height: 85%;
}

.projectMainCategory {
  position: relative;
  font-weight: 700;
  
}

.projectMainCategorySide {
  position: relative;
  font-size: 14px;
  font-weight: 700;
}

.projectDescTitle {
  width: 75%;
  font-weight: 700;
  color: #444444;

  top: 50%;
  margin: 0;
  position: absolute;

  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.projectDescTitleSide {
  font-weight: 700;
  color: #444444;
  font-size: 28px;
  width: 80%;
  position: relative;

  padding-top: 20px;
}

.categoryLink {
  font-size: 9px;
  font-weight: 700;
  padding: 2px;
  padding-left: 5px;
  padding-right: 5px;
  border: solid 1px #00000099;
  border-radius: 0px;
  text-align: center;
}

.categoryLinkPadding {
  padding: 1px;
}

.categoryLinkSelected {
  font-size: 11px;
  font-weight: 700;
  padding: 3px;
  padding-left: 5px;
  padding-right: 5px;
  border: solid 1px #00000099;
  border-radius: 0px;
  text-align: center;
}

.categoryLinkPaddingSelected {
  padding: 4px;
}

.categoryLinkFrameSelected {
  position: relative;
  top: 0px;
  right: 0px;
  top: 30px;
  left: -3px;
  padding-bottom: 25px;
}

.categoryLinkFrame {
  position: absolute;
  top: 0px;
  right: 0px;
  top: 20px;
  float: right;
  text-align: right;
  padding-right: 5%;
}

.projectTitleBuffer {
  padding-top: 0px;
}

.projectLineEvents {
  background-color: #00bb00;
}

.projectLineClients {
  background-color: #dddd00;
}

.projectLineResearch {
  background-color: #ffffff;
  border: solid 1px #00000055;
}

.projectLine {
  position: relative;
  height: 15px;
  width: 170px;
  top: 12px;
}

.emdash {
  position: relative;
  top: -0px;
}
</style>